import { makeImmutable } from "../core";
export class CartStorageManager {
    constructor(restaurantSlug) {
        this.localStorageCartKey = `client_cart_${restaurantSlug}`;
        this.localStoragePreviousOrderCartKey = `client_previousOrder_${restaurantSlug}`;
        this.migrateKeys();
        makeImmutable(this);
    }
    // NOTICE Remove this code when not needed anymore
    migrateKeys() {
        const legacyCart = localStorage.getItem("client_cart");
        if (legacyCart !== null &&
            localStorage.getItem(this.localStorageCartKey) === null) {
            localStorage.setItem(this.localStorageCartKey, legacyCart);
            localStorage.removeItem("client_cart");
        }
        const legacyPrevious = localStorage.getItem("client_previousOrder");
        if (legacyPrevious !== null &&
            localStorage.getItem(this.localStoragePreviousOrderCartKey) === null) {
            localStorage.setItem(this.localStoragePreviousOrderCartKey, legacyPrevious);
            localStorage.removeItem("client_previousOrder");
        }
    }
    get now() {
        return new Date().getTime();
    }
    clearCart() {
        localStorage.removeItem(this.localStorageCartKey);
    }
    storePreviousOrderCart() {
        const cartDataString = localStorage.getItem(this.localStorageCartKey);
        if (cartDataString !== null) {
            localStorage.setItem(this.localStoragePreviousOrderCartKey, cartDataString);
        }
    }
    restorePreviousOrderCart() {
        const prevCartDataString = localStorage.getItem(this.localStoragePreviousOrderCartKey);
        if (prevCartDataString === null) {
            return;
        }
        const cartData = JSON.parse(prevCartDataString);
        const { now } = this;
        const cartDataString = JSON.stringify({
            savedAt: now,
            cart: cartData.cart,
        });
        localStorage.setItem(this.localStorageCartKey, cartDataString);
    }
    readCart() {
        const cartDataString = localStorage.getItem(this.localStorageCartKey);
        if (cartDataString === null) {
            // NOTICE No cart stored before
            return null;
        }
        const cartData = JSON.parse(cartDataString);
        const cartAgeSeconds = (this.now - cartData.savedAt) / 1000;
        console.log(`Cart loaded, age=${cartAgeSeconds} seconds`);
        return cartData.cart;
    }
    writeCart(cartStorageData) {
        const cartData = {
            savedAt: this.now,
            cart: cartStorageData,
        };
        const cartDataString = JSON.stringify(cartData);
        localStorage.setItem(this.localStorageCartKey, cartDataString);
    }
    erase() {
        localStorage.removeItem(this.localStorageCartKey);
        localStorage.removeItem(this.localStoragePreviousOrderCartKey);
    }
}
